"use client";
import { Button } from "@mui/material";
import { cn } from "@onair/utils/cn";
import { memo } from "react";

type CatItem = { id: number; title: string; documentId: number };
export interface CategoryFilterProps {
	items: CatItem[];
	selectedIds?: number[];
	onSelect?: (item: CatItem) => void;
}
const CategoryFilter: React.FC<CategoryFilterProps> = ({
	items,
	selectedIds,
	onSelect,
}) => {
	return (
		<div
			className="overflow-x-auto scroll-smooth"
			style={{ scrollbarWidth: "thin" }}
		>
			<div className="flex gap-3 whitespace-nowrap w-fit pb-3 ">
				{items.map((cat) => (
					<Button
						key={cat.id}
						variant="outlined"
						className={cn("hover:bg-black hover:text-white", {
							"bg-black !text-white": selectedIds?.includes(cat.id),
						})}
						onClick={() => onSelect?.(cat)}
					>
						{cat?.title}
					</Button>
				))}
			</div>
		</div>
	);
};
export default memo(CategoryFilter);
